import React from 'react';
import { Page, PageBody, PageHeader } from '../../components/ui';
import { TTCDataProductsWorkbench } from '../../components/ttc-data-products/TTCDataProductsWorkbench';

export default function TTCDataProductsPage() {
  return (
    <Page layout="full-width">
      <PageHeader
        title="TTC Data Products"
        description="Map source endpoints into durable TTC data product contracts."
      />
      <PageBody fill padded={false}>
        <TTCDataProductsWorkbench />
      </PageBody>
    </Page>
  );
}
